import React from 'react'
import AreaRange from './AreaRange.styled'

const AreaRangeComponent = () => (
  <AreaRange>
    <AreaRange.InputWrapper>
      <AreaRange.Input
        name='minArea'
        placeholder='từ (m2)'
      />
    </AreaRange.InputWrapper>

    <AreaRange.InputWrapper>
      <AreaRange.Input
        name='maxArea'
        placeholder='đến (m2)'
      />
    </AreaRange.InputWrapper>
  </AreaRange>
)

export default AreaRangeComponent
